import {  registerService } from './messaging';

export const initFirebase = () => {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', async () => {
            registerService();
        });
    }
}